module.exports = __webpack_public_path__ + "img/webSite-7.111b69b2.png";